import Velocity from "velocity-animate";
import Sentence from "@/components/Sentence/Sentence.vue";
import StarSentenceButton from "@/components/StarSentenceButton/StarSentenceButton.vue";
import { adSubdomain } from "@/common/functions";

export default {
    components: {
        Sentence,
        SentenceReport: () =>
            import(
                /* webpackChunkName: "sentenceReport" */ "@/components/SentenceReport/SentenceReport.vue"
            ),
        StarSentenceButton,
        ThumbsVote: () =>
            import(/* webpackChunkName: "thumbsVote" */ "@/components/ThumbsVote/ThumbsVote.vue")
    },
    props: {
        word: {
            type: String
        },
        sentence: {
            type: Object
        }
    },
    data() {
        return {
            lsRecord: "my-starred-sentences",
            recordItem: `${this.word}-${this.sentence.id}-${this.sentence.sentence}`,
            subdomain: adSubdomain(this.$route.meta.subdomain),
            clicked: false
        };
    },
    methods: {
        hasSentenceStar() {
            try {
                if (localStorage.getItem(this.lsRecord)) {
                    let sentences = JSON.parse(localStorage.getItem(this.lsRecord));
                    if (sentences.includes(this.recordItem)) {
                        this.clicked = true;
                    } else {
                        this.clicked = false;
                    }
                } else {
                    this.clicked = false;
                }
            } catch (e) {
                this.clicked = false;
                console.log("LocalStorage is not available.");
            }
        },
        // Sentence bg animation hooks
        enter(el, done) {
            Velocity(el, { translateX: "0" }, { duration: 370 });
            Velocity(
                el,
                { opacity: "0.35" },
                { queue: false },
                { duration: 350 },
                { complete: done }
            );
        },
        leave(el, done) {
            Velocity(el, { opacity: "0" }, { duration: 350 });
            Velocity(
                el,
                { translateX: "-100%" },
                { queue: false },
                { duration: 370 },
                { complete: done }
            );
        }
    },
    mounted() {
        this.hasSentenceStar();
        this.$root.$on(`refresh-${this.recordItem}`, val => {
            this.clicked = val;
        });
    },
    beforeDestroy() {
        this.$root.$off(`refresh-${this.recordItem}`);
    }
};



// WEBPACK FOOTER //
// ./src/components/SentenceItem/SentenceItem.js